import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
import * as i1 from "./request.service";
export class TreeSpeciesService {
    constructor(requestService) {
        this.requestService = requestService;
    }
    getAllSpecies() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.getApi('treespecies');
            return result.data;
        });
    }
    getPlantingSiteSpecies(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.getApi('treespecies/plating-species/' + id);
            return result.data;
        });
    }
    saveSpecies(species, plantingSiteId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let data = {
                speciesId: species.speciesId,
                count: species.count,
                species: species.species,
                description: species.description
            };
            if (species.id) {
                yield this.requestService.patch('plantingSites/update-planting-site-species', Object.assign({ id: species.id }, data));
                return species.id;
            }
            else {
                let result = yield this.requestService.post('plantingSites/create-planting-site-species', Object.assign({ plantingSiteId: plantingSiteId }, data));
                return result.data;
            }
        });
    }
    deleteSpecies(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.requestService.delete('treespecies/delete?id=' + id);
            return result.data;
        });
    }
    createSpeies(species) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let data = {
                species: species.species,
                description: species.description
            };
            let result = yield this.requestService.post('treespecies/create-species', Object.assign({}, data));
            return result.data;
        });
    }
    updateSpeies(species) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let data = {
                id: species.id,
                species: species.species,
                description: species.description
            };
            let result = yield this.requestService.post('treespecies/create-species', Object.assign({}, data));
            return result.data;
        });
    }
}
TreeSpeciesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TreeSpeciesService_Factory() { return new TreeSpeciesService(i0.ɵɵinject(i1.RequestService)); }, token: TreeSpeciesService, providedIn: "root" });
